/// <amd-module name="NetSuite.LogoList.LogoListCCT"/>
define("NetSuite.LogoList.LogoListCCT", ["require", "exports", "NetSuite.LogoList.LogoListCCT.View"], function (require, exports, LogoListCCT_View_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            this.registerCCT(container);
        },
        registerCCT: function (container) {
            container.getComponent('CMS').registerCustomContentType({
                id: 'cct_netsuite_logolist',
                view: LogoListCCT_View_1.LogoListCCTView,
                options: {
                    container: container,
                },
            });
        },
    };
});
